<template>
  <i class="material-icons action-icon" @click="deleteCategory">
    delete
  </i>
</template>

<script>
import db from "../db.js";
import eventHub from "../eventHub.js";

export default {
  name: "delete-category",
  props: {
    categoryId: String,
  },
  methods: {
    deleteCategory() {
      let really = confirm("Are you sure you want to delete this category?");

      if (really) {
        db.trashCategory(this.categoryId);
        eventHub.$emit("set-category-modal-visibility", { isVisible: false });
      }
    },
  },
};
</script>

<style scoped>
.material-icons.action-icon {
  font-size: 24px;
  margin: 0.25rem;
  color: #c0c0c0;
}

.material-icons.action-icon:hover {
  color: #e74c3c;
}
</style>



// WEBPACK FOOTER //
// DeleteCategory.vue?862d9734